// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1434":"0f517ecb","4137":"1559c54b","6224":"5c8c1076"}[chunkId] + ".chunk.css";
};